import { Action } from 'redux';
import { DataSources, Enrolment, Enrolments } from 'services/resources';
import { FailureActionTypes } from 'services/utilityTypes';

const TELEMATICS_ACTION_BASE = 'app/services/Telematics/';

export enum ActionTypes {
  SET_DATASOURCES_LOADING = TELEMATICS_ACTION_BASE + 'SET_DATASOURCES_LOADING',
  GET_DATASOURCES_SUCCESS = TELEMATICS_ACTION_BASE + 'GET_DATASOURCES_SUCCESS',
  GET_DATASOURCES_FAIL = TELEMATICS_ACTION_BASE + 'GET_DATASOURCES_FAIL',
  SET_ENROLMENTS_LOADING = TELEMATICS_ACTION_BASE + 'SET_ENROLMENTS_LOADING',
  GET_ENROLMENTS_SUCCESS = TELEMATICS_ACTION_BASE + 'GET_ENROLMENTS_SUCCESS',
  GET_ENROLMENTS_FAIL = TELEMATICS_ACTION_BASE + 'GET_ENROLMENTS_FAIL',
  CREATE_ENROLMENT_SUCCESS = TELEMATICS_ACTION_BASE + 'CREATE_ENROLMENT_SUCCESS',
  CREATE_ENROLMENT_FAIL = TELEMATICS_ACTION_BASE + 'CREATE_ENROLMENT_FAIL',
  UPDATE_ENROLMENT_SUCCESS = TELEMATICS_ACTION_BASE + 'UPDATE_ENROLMENT_SUCCESS',
  UPDATE_ENROLMENT_FAIL = TELEMATICS_ACTION_BASE + 'UPDATE_ENROLMENT_FAIL',
  DELETE_ENROLMENT_SUCCESS = TELEMATICS_ACTION_BASE + 'DELETE_ENROLMENT_SUCCESS',
  DELETE_ENROLMENT_FAIL = TELEMATICS_ACTION_BASE + 'DELETE_ENROLMENT_FAIL',
}

type TelematicsFailureActionTypes = FailureActionTypes<ActionTypes>;

interface ActionBase extends Action {
  type: ActionTypes;
  payload?: Record<string, unknown>;
}

interface GetDatasourcesAction extends ActionBase {
  type: ActionTypes.GET_DATASOURCES_SUCCESS;
  payload: {
    datasources: DataSources;
  };
}

interface GetEnrolmentsAction extends ActionBase {
  type: ActionTypes.GET_ENROLMENTS_SUCCESS;
  payload: {
    enrolments: Enrolments;
  };
}

interface CreateEnrolmentAction extends ActionBase {
  type: ActionTypes.CREATE_ENROLMENT_SUCCESS;
  payload: {
    enrolment: Enrolment;
  };
}

interface UpdateEnrolmentAction extends ActionBase {
  type: ActionTypes.UPDATE_ENROLMENT_SUCCESS;
  payload: {
    enrolment: Enrolment;
  };
}

interface DeleteEnrolmentAction extends ActionBase {
  type: ActionTypes.DELETE_ENROLMENT_SUCCESS;
  payload: {
    enrolmentId: number;
  };
}

interface SetDatasourcesLoadingAction extends ActionBase {
  type: ActionTypes.SET_DATASOURCES_LOADING;
}

interface SetEnrolmentsLoadingAction extends ActionBase {
  type: ActionTypes.SET_ENROLMENTS_LOADING;
}

interface FailureAction extends ActionBase {
  type: TelematicsFailureActionTypes;
  payload: {
    error: string;
  };
}

export type TelematicsAction =
  | GetDatasourcesAction
  | GetEnrolmentsAction
  | CreateEnrolmentAction
  | UpdateEnrolmentAction
  | DeleteEnrolmentAction
  | SetDatasourcesLoadingAction
  | SetEnrolmentsLoadingAction
  | FailureAction;

export const receivedGetDatasourcesSuccess = (datasources: DataSources): TelematicsAction => ({
  type: ActionTypes.GET_DATASOURCES_SUCCESS,
  payload: {
    datasources,
  },
});

export const receivedGetDatasourcesFail = (error: string): FailureAction => ({
  type: ActionTypes.GET_DATASOURCES_FAIL,
  payload: { error },
});

export const receivedGetEnrolmentsSuccess = (enrolments: Enrolments): TelematicsAction => ({
  type: ActionTypes.GET_ENROLMENTS_SUCCESS,
  payload: {
    enrolments,
  },
});

export const receivedGetEnrolmentsFail = (error: string): FailureAction => ({
  type: ActionTypes.GET_ENROLMENTS_FAIL,
  payload: { error },
});

export const receivedCreateEnrolmentSuccess = (enrolment: Enrolment): TelematicsAction => ({
  type: ActionTypes.CREATE_ENROLMENT_SUCCESS,
  payload: {
    enrolment,
  },
});

export const receivedCreateEnrolmentFail = (error: string): FailureAction => ({
  type: ActionTypes.CREATE_ENROLMENT_FAIL,
  payload: { error },
});

export const receivedUpdateEnrolmentSuccess = (enrolment: Enrolment): TelematicsAction => ({
  type: ActionTypes.UPDATE_ENROLMENT_SUCCESS,
  payload: {
    enrolment,
  },
});

export const receivedUpdateEnrolmentFail = (error: string): FailureAction => ({
  type: ActionTypes.UPDATE_ENROLMENT_FAIL,
  payload: { error },
});

export const receivedDeleteEnrolmentSuccess = (enrolmentId: number): TelematicsAction => ({
  type: ActionTypes.DELETE_ENROLMENT_SUCCESS,
  payload: {
    enrolmentId,
  },
});

export const receivedDeleteEnrolmentFail = (error: string): FailureAction => ({
  type: ActionTypes.DELETE_ENROLMENT_FAIL,
  payload: { error },
});

export const startDatasourcesLoading = (): SetDatasourcesLoadingAction => ({
  type: ActionTypes.SET_DATASOURCES_LOADING,
});

export const startEnrolmentsLoading = (): SetEnrolmentsLoadingAction => ({
  type: ActionTypes.SET_ENROLMENTS_LOADING,
});
